import React, { useEffect, useState } from "react";
import {
  List,
  Typography,
  Avatar,
  Row,
  Col,
  Card,
  Tag,
  Pagination,
  Switch,
  Tooltip,
  Spin,
  Popconfirm,
} from "antd";
import {
  ModuleColor,
  ModuleTagName,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
import { CheckSquareTwoTone, UserOutlined } from "@ant-design/icons";
import NotificationDetails from "./NotficationDetails";
import "./NotificationsStyles.css";
import moment from "moment";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import useNonDispatchNotifications from "../../../../components/AdminComponents/customHooks/useNonDispatchNotifications";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import axiosInstance from "../../../../api/Axios";
const { Text } = Typography;

const SideTableNotifications = ({ from }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [activeNotificationId, setActiveNotificationId] = useState();
  console.log(id);
  const [changedState, setChangedState] = useState(false);

  const [filterData, setFilterData] = useState({
    pageSize: 10,
    currentPage: 1,
    search: "",
    read: true,
    readStatus: true,
  });
  const { pageSize, currentPage, read, readStatus } = filterData;
  const { notifications, notificationCount, notificationsLoader } =
    useNonDispatchNotifications({
      state: id ? false : read,
      id: activeNotificationId,
      readStatus: readStatus,
      pageSize: pageSize,
      currentPage: currentPage,
    });

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
      currentPage: 1,
    }));
    setActiveNotificationId(null);
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
    setActiveNotificationId(null);
  };
  const handleItemClick = (id, item) => {
    setActiveNotificationId(id);
    setFilterData((prevData) => ({
      ...prevData,
      readStatus: item?.read,
    }));
  };

  const handleSwitchChange = (checked) => {
    setChangedState(true);
    setFilterData((prevData) => ({
      ...prevData,
      read: checked,
    }));
    setActiveNotificationId(null);
    if (checked && id) {
      const newPath = location.pathname.replace(`/${id}`, "/"); // Remove ID from the URL
      navigate(newPath, { replace: true });
    }
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const markAllhasRead = async () => {
    try {
      await axiosInstance.put(`/notificationevent/mark_all_read/`, "", {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      handleSwitchChange(true);
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
    }
  };

  useEffect(() => {
    if (
      currentPage === 1 &&
      pageSize === 10 &&
      !activeNotificationId &&
      notificationCount > 0 &&
      !changedState
    ) {
      setActiveNotificationId(notifications?.[0]?.id);
      setFilterData((prevData) => ({
        ...prevData,
        readStatus: notifications?.[0]?.read,
      }));
    }
  }, [
    activeNotificationId,
    currentPage,
    notificationCount,
    notifications,
    pageSize,
    changedState,
  ]);
  useEffect(() => {
    if (id && notificationCount > 0) {
      setFilterData((prevData) => ({
        ...prevData,
        read: false,
        readStatus: false,
      }));
      setActiveNotificationId(id);
    }
  }, [id, notificationCount]);
  const showModal = () => {};
  const ResetFields = () => {};
  const handleSearchChange = () => {};
  return (
    <div
    // className="notifications"
    // style={{ marginTop: from === "TN_ADMIN" ? "50px" : "0px" }}
    >
      <CommonTopDetails
        title={!read ? "Unread Messages" : "Message Summary"}
        titleSuffix={`${notificationCount || 0} content(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        filterAction={true}
        filterUrl={false}
        marginPass={"15px"}
        filterButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
        resetButtonProps={{
          modalProps: ResetFields,
        }}
        customContent={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Switch
              style={{
                backgroundColor: read ? "#50C878" : "blue",
                minWidth: "90px",
              }}
              checked={read}
              onChange={handleSwitchChange}
              checkedChildren="ALL"
              unCheckedChildren="UNREAD"
            />
            {!read && notificationCount > 0 && (
              <Tooltip title="Mark All As Read">
                <Popconfirm
                  title="Are you sure you want to mark all as read?"
                  onConfirm={markAllhasRead}
                  okText="Yes"
                  cancelText="No"
                >
                  <CheckSquareTwoTone
                    style={{
                      fontSize: "30px",

                      cursor: "pointer",
                    }}
                  />
                </Popconfirm>
              </Tooltip>
            )}
          </div>
        }
      />

      <Spin spinning={notificationsLoader}>
        <div
          style={{
            display: "flex",
            padding: "20px",
            paddingTop: "10px",
            gap: "16px",
            height: `${remainingViewportHeight(19)}px`,
            backgroundColor: "#f4f4f4",
          }}
          className="notifications"
        >
          <Card
            //   title="Notifications"
            bordered
            style={{
              flex: "0 0 38%",
              borderRadius: "8px",
              overflowY: "auto",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <List
              itemLayout="vertical"
              dataSource={notifications}
              renderItem={(item) => (
                <Card
                  hoverable
                  onClick={() => handleItemClick(item.id, item)}
                  style={{
                    marginBottom: "10px",
                    border:
                      Number(activeNotificationId) === item.id
                        ? "2px solid #1890ff"
                        : "1px solid #f0f0f0",
                    backgroundColor: item?.read ? "#ededed" : "white",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                  size="small"
                >
                  {/* Row for Sender, Receiver, and Notification Type */}
                  <Row align="middle" gutter={16}>
                    <Col>
                      <Avatar
                        src={
                          item.sentBy.image ||
                          "https://cdn-icons-png.flaticon.com/512/1828/1828970.png"
                        }
                        alt={item.sentBy.name}
                        size="small"
                      />
                    </Col>
                    <Col flex="auto">
                      <Text
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          //   textDecoration: "underline",
                        }}
                        className="notifications"
                      >
                        {item.type}
                      </Text>
                      <br />
                      <Text
                        style={{ color: "#595959", fontSize: "11px" }}
                        className="notifications"
                      >
                        <Text
                          style={{
                            color: "#595959",
                            fontSize: "13px",
                            fontWeight: "500",
                          }}
                          className="notifications"
                        >
                          {item.sentBy.name || "System"}
                        </Text>{" "}
                        →{" "}
                        <Text
                          style={{
                            color: "#595959",
                            fontSize: "13px",
                            fontWeight: "500",
                          }}
                          className="notifications"
                        >
                          {Array.isArray(item?.receivedBy) &&
                            (item.receivedBy.length === 1
                              ? item.receivedBy[0]?.name
                              : `${item.receivedBy[0]?.name} and ${
                                  item.receivedBy.length - 1
                                } others`)}
                        </Text>
                      </Text>
                    </Col>
                    <Col style={{ display: "flex", alignItems: "center" }}>
                      <Tag
                        color={ModuleColor(item.application)}
                        title={item.application}
                        style={{ marginRight: "8px" }}
                        size="small"
                      >
                        <span
                          style={{
                            color: "black",
                            fontWeight: "500",
                          }}
                        >
                          {ModuleTagName(item.application)}
                        </span>
                      </Tag>
                      <Avatar
                        style={{
                          background:
                            Array.isArray(item?.receivedBy) &&
                            item.receivedBy.length > 1
                              ? "lightblue"
                              : "",
                        }}
                        src={
                          Array.isArray(item?.receivedBy) &&
                          item.receivedBy.length === 1 &&
                          item.receivedBy[0]?.image
                            ? item.receivedBy[0].image
                            : null
                        }
                        icon={
                          Array.isArray(item?.receivedBy) &&
                          item.receivedBy.length > 1 ? (
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: "500",
                                color: "black",
                              }}
                            >
                              {item.receivedBy.length}
                            </span>
                          ) : (
                            Array.isArray(item?.receivedBy) &&
                            item.receivedBy.length === 1 &&
                            !item.receivedBy[0]?.image && <UserOutlined />
                          )
                        }
                        alt={
                          Array.isArray(item?.receivedBy) &&
                          item.receivedBy.length === 1
                            ? item.receivedBy[0]?.name
                            : "participants"
                        }
                        size="small"
                      />
                    </Col>
                  </Row>

                  <div
                    style={{
                      marginTop: "5px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "75%",
                      }}
                      className="notifications"
                    >
                      {item.content}
                    </Text>
                    <Text
                      style={{ color: "#8c8c8c", fontSize: "11px" }}
                      className="notifications"
                    >
                      {moment(item.timestamp).format("MMM DD YYYY h:mm A")}
                    </Text>
                  </div>
                </Card>
              )}
            />
          </Card>
          <div
            style={{
              flex: "1",
              display: "flex",
              flexDirection: "column",
              paddingLeft: "10px",
            }}
          >
            <div
              style={{
                flex: "0 0 95%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <NotificationDetails
                selectedNotificationID={activeNotificationId}
                origin={from}
              />
            </div>
            <div
              style={{
                textAlign: "left",
                marginTop: "auto",
              }}
            >
              {read && (
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={notificationCount}
                  onShowSizeChange={onShowSizeChange}
                  onChange={onPageChange}
                  showSizeChanger
                  size="small"
                  pageSizeOptions={["5", "10", "15", "20", "30"]}
                />
              )}
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default SideTableNotifications;
